import { localize } from 'helpers/router';

export const LANDING = localize('/');
